import { useState } from 'react'
import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router-dom'
import organiaztionsTableAtom from '../../componenets/OrganizationsTable/organizations.atom'
import organizationsApi from '../../organizations.api'
import OrganizationSheet from '../../componenets/OrganizationSheet'

const CreateOrganizationPage = () => {
  const navigate = useNavigate()
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft] = useState({ name: '', contact: '' })
  const setState = useSetRecoilState(organiaztionsTableAtom)

  const handleChange = (val: any, name: string) => {
    setDraft((prev) => ({ ...prev, [name]: val }))
  }

  const handleSave = () => {
    wait(organizationsApi.create(draft), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: [resp.body, ...prev.items] }))
        navigate('/admin/organizations')
      }
    })
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Создание организации</h2>
          </div>
        </div>
        <OrganizationSheet organization={draft} onChange={handleChange}>
          <Button theme='primary' loading={loading} onClick={handleSave} style={{ width: 'fit-content' }}>
            Создать
          </Button>
        </OrganizationSheet>
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default CreateOrganizationPage
